import { useContext } from "react";
import { APIErrorContext, APIErrorContextType } from "..";

export const useApiError = (): APIErrorContextType => {
    const { error, addError, removeError } = useContext(APIErrorContext);

    return { error, addError, removeError };
};
